const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $in: ['object.project-type.options.project-development', 'object.project-type.options.plot'] } }]
}

export default conditions
